// api-clients.js
import axios from 'axios';
// import * as store from '../stores/index';

const apiClient = axios.create({
  baseURL: '/api',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json',
  },
});

// apiClient.interceptors.request.use(
//   (config) => {
//     store.default.dispatch('loader/setLoadingAction', true);
//     return config;
//   },
//   (error) => {
//     store.default.dispatch('loader/setLoadingAction', false);
//     return Promise.reject(error);
//   },
// );

// apiClient.interceptors.response.use(
//   (response) => {
//     store.default.dispatch('loader/setLoadingAction', false);
//     return response;
//   },
//   (error) => {
//     store.default.dispatch('loader/setLoadingAction', false);
//     return Promise.reject(error);
//   },
// );

export default apiClient;
